import * as React from 'react';
import { useLocation } from 'react-router';
import { isBranch } from '../../../utils/locationUtils';
import { StoreContext } from '../../appContext/StoreProvider';
import { SearchButton } from './SearchButton';
import style from './RelatedSitesAndSearchContainer.scss';
import { RelatedSites } from './RelatedSites';
import classnames from 'classnames';
import { withActiveLink } from './utils';
import { isClientSide } from '../../../common/utils';

export const RelatedSitesAndSearchContainer = ({
  openSearchModal,
  isPreview,
  staticContext,
}) => {
  const { store } = React.useContext(StoreContext);
  const location = useLocation();
  const withNotificationBar = isBranch(location) || isPreview;

  const host = isClientSide() ? window.location.host : staticContext.host;
  const relatedSitesWithLinks = withActiveLink(
    store.viewer?.viewerConfig?.relatedSites,
    location.pathname,
    host,
    store,
  );

  const shouldShowRelatedSites =
    store.viewer?.viewerConfig?.relatedSites?.length > 1;

  return (
    <div
      className={classnames({
        [style.relatedSitesAndSearchContainer]: true,
        [style.withNotificationBar]: withNotificationBar,
        [style.withoutRelatedSites]: !shouldShowRelatedSites,
      })}
    >
      {shouldShowRelatedSites && (
        <span className={style.relatedSitesContainer} data-hook="related-sites">
          <RelatedSites links={relatedSitesWithLinks} />
        </span>
      )}
      <div
        className={classnames({
          [style.searchContainer]: true,
          [style.withoutRelatedSites]: !shouldShowRelatedSites,
        })}
      >
        <SearchButton openModal={openSearchModal} />
      </div>
    </div>
  );
};
